import { render, staticRenderFns } from "./ClinicalUnitStorages.vue?vue&type=template&id=26095c12"
import script from "./ClinicalUnitStorages.vue?vue&type=script&lang=js"
export * from "./ClinicalUnitStorages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports